import axios from 'axios';
import { getApiUrl } from '@/config/api';

const BASE = '/api/CatAlmacen';

export default {
  async listar(filtro = {}) {
    const response = await axios.post(getApiUrl(`${BASE}/listar`), filtro);
    return response.data;
  },

  async leer(model) {
    const response = await axios.post(getApiUrl(`${BASE}/lectura`), model);
    return response.data;
  },

  async guardar(model) {
    await axios.post(getApiUrl(`${BASE}/guardar`), model);
  },

  async borrar(model) {
    const response = await axios.post(getApiUrl(`${BASE}/borrar`), model);
    return response.data;
  },

  async sincronizarErp() {
    const response = await axios.post(getApiUrl(`${BASE}/sincronizar-erp`));
    return response.data;
  }
};
